const resolveMessageUserId = (user) => user && (user.noUser || user.idUser || user._id || user.id);

const isOwnMessage = ({ currentUser, message }) => {
   const currentUserId = resolveMessageUserId(currentUser);
   const messageUserId = resolveMessageUserId(message && message.user);
   return currentUserId != null && messageUserId != null && String(currentUserId) === String(messageUserId);
};

export { isOwnMessage, resolveMessageUserId };
